import { ReactElement, SVGProps } from 'react'
export const SvgMir = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg width={64} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={64} height={32} rx={4} fill="#fff" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.313 10.002c.417-.002 1.655-.11 2.18 1.6.353 1.152.916 3.04 1.688 5.661h.315c.828-2.764 1.397-4.651 1.707-5.66.53-1.729 1.855-1.6 2.384-1.6h4.09V22.29h-4.168v-7.24h-.28l-2.323 7.241h-3.135l-2.324-7.247h-.28v7.247H9V10.002h4.313Zm18.348 0v7.247h.333l2.826-5.959a2.236 2.236 0 0 1 1.718-1.288h4.033V22.29h-4.255v-7.247h-.332l-2.771 5.96c-.549 1.18-1.773 1.287-1.773 1.287h-4.033V10.002h4.254Zm23.616 5.84c-.593 1.624-2.457 2.788-4.52 2.788h-4.463v3.66h-4.046v-6.448h13.029Z"
      fill="#0F754E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.918 10.066h-8.915c.212 2.736 2.651 5.078 5.176 5.078h8.346c.482-2.274-1.176-5.078-4.607-5.078Z"
      fill="url(#mir_svg__a)"
    />
    <defs>
      <linearGradient
        id="mir_svg__a"
        x1={55.607}
        y1={13.261}
        x2={42.003}
        y2={13.261}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1F5CD7" />
        <stop offset={1} stopColor="#02AEFF" />
      </linearGradient>
    </defs>
  </svg>
)
